var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66217 1.8C5.18329 1.8 4.73763 2.04477 4.48071 2.44889L2.60456 5.40001H17.9413L16.3761 2.52972C16.2534 2.30478 16.0744 2.12247 15.8617 1.99617C15.6489 1.86988 15.4032 1.8 15.1469 1.8H5.66217ZM18.5655 6.99162C18.5276 6.99715 18.4888 7.00001 18.4493 7.00001H2.14264C2.04807 7.00001 1.95734 6.9836 1.87313 6.95348C1.82474 7.18302 1.80001 7.41801 1.80001 7.6548V16.2C1.80001 16.5868 1.95584 16.9357 2.21006 17.1899C2.46429 17.4442 2.81319 17.6 3.20001 17.6H17.2C17.5868 17.6 17.9357 17.4442 18.19 17.1899C18.4442 16.9357 18.6 16.5868 18.6 16.2V7.47471C18.6 7.31255 18.5884 7.15112 18.5655 6.99162ZM3.13047 1.59049C3.68101 0.724505 4.63599 0.199997 5.66217 0.199997H15.1469C15.6959 0.199997 16.2231 0.350031 16.6785 0.620375C17.1338 0.890718 17.518 1.28176 17.7808 1.7637L19.5897 5.08087C19.9902 5.81521 20.2 6.63828 20.2 7.47471V16.2C20.2 17.0282 19.8633 17.7793 19.3213 18.3213C18.7793 18.8633 18.0282 19.2 17.2 19.2H3.20001C2.37181 19.2 1.62071 18.8633 1.07869 18.3213C0.536674 17.7793 0.200012 17.0282 0.200012 16.2V7.6548C0.200012 6.70463 0.470751 5.77414 0.980518 4.97229L3.13047 1.59049ZM6.44408 11.2606C6.44408 10.8187 6.80225 10.4606 7.24408 10.4606H13.1902C13.6321 10.4606 13.9902 10.8187 13.9902 11.2606C13.9902 11.7024 13.6321 12.0606 13.1902 12.0606H7.24408C6.80225 12.0606 6.44408 11.7024 6.44408 11.2606Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.df19fe52b4f1adb657b96195e9ed6e27.svg";
export { ForwardRef as ReactComponent };